import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom";
import styles from './cssModules/index.module.css';
import waiting from './gallary/waiting.png'
import Spinner from 'react-bootstrap/Spinner';

export default function OrderRequest({ loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    const userUrl = process.env.REACT_APP_API_URL;

    const [totalItems, setTotalItems] = useState(0);
    const [totalValue, setTotalValue] = useState(0);
    const [prodls, setProdLs] = useState();

    const [loading, setLoading] = useState(false);

    const [pageno, setPageno] = useState(1);
    const [noOfObs, setNoOfObs] = useState(null);
    const [role, setRole] = useState(null)

    const navigate = useNavigate();

    let S3_URL = process.env.REACT_APP_S3_URL;

    let jToken = localStorage.getItem('token');

    // Spinner Show enabling
    const [showSpinner, setShowSpinner] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiURL}/api/orders`, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'Application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    credentials: "include"
                })
                if (response.status === 500) {
                    throw new Error('Error while fetching return data');
                } else {

                    if (response.status === 200) {
                        const res = await response.json();
                        console.log(res);
                        setTotalItems(res.metrics?.totalOntransit);
                        setTotalValue(res.metrics?.totalOntransitVolume ? res.metrics.totalOntransitVolume : 0);
                        setProdLs(res.items);
                        setNoOfObs(res.noObs);
                        setRole(res.role);
                        setLoading(true);
                    } else {
                        await loginStatus();
                        navigate('/login');
                    }
                }
            } catch (error) {
                // await loginStatus();
                navigate('/error')
                console.log(error.message);
            }
        }
        fetchData();
    }, [jToken, loginStatus, apiURL, navigate])

    const changePage = async (event, ind) => {
        try {
            event.preventDefault();
            const increment = !ind ? 1 : -1;
            const response = await fetch(`${apiURL}/api/orders`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify({
                    pageNo: pageno + increment
                }),
                credentials: "include"
            })
            if (response.status === 500) {
                throw new Error('Error while changing the page');
            } else {
                if (response.status === 200) {
                    const res = await response.json();
                    setProdLs(res.prod);
                    setNoOfObs(res.noObs);
                } else {
                    await loginStatus();
                    navigate('/login');
                }
            }
        } catch (error) {
            // await loginStatus();
            navigate('/error');
            console.log(error.message);
        }
    }

    async function proceeded(purchaseId) {
        const fetchData = async () => {
            try {
                setShowSpinner(true);
                const response = await fetch(`${apiURL}/order/received`, {
                    method: 'POST',
                    headers: {
                        'Content-type': 'Application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    body: JSON.stringify({ id: purchaseId }),
                    credentials: 'include'
                });
                if (response.status === 500) {
                    throw new Error('Error occured while saving product');
                } else {
                    if (response.status === 200) {
                        alert('Order has been proceeded!');
                        setShowSpinner(false);
                        window.location.reload();
                    } else {
                        await loginStatus();
                        navigate('/login');
                    }
                }

            } catch (error) {
                navigate('/error');
                console.log(error.message);
            }
        }
        fetchData();
    }

    return (
        <>
            {!loading ? (
                <div className={`${styles.spinnerDiv}`}>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            ) :
                showSpinner ? (
                    <div className={`${styles.waitingSpinnerDiv}`}>
                        <Spinner animation="grow" style={{ width: "100px", height: "100px" }} />
                    </div>
                ) :
                    parseInt(totalItems) === 0 ? (
                        <>
                            <div className={`${styles.noNotificationDiv}`}>
                                <span className={`${styles.noNotificationSpan}`}>
                                    We're waiting for the order along with you!
                                </span>
                                <img src={waiting} alt='Waiting for orders' style={{ height: '60px' }} />
                            </div>
                        </>
                    ) : (<>
                        <div className={`${styles.sellerDBMetricsDIV}`}>
                            <div className={`${styles.sellerDBMEtric}`}>
                                <span>
                                    Total orders
                                </span>
                                <span>{totalItems}</span>
                            </div>
                            <div className={`${styles.sellerDBMEtric}`}>
                                <span>
                                    Total order value
                                </span>
                                <span>{totalValue}</span>
                            </div>
                        </div>
                        <div>
                            <div className={`${styles.sellerDBPRODLS}`}>
                                {prodls && prodls.map((item, index) => {
                                    return (
                                        <div className={`${styles.sellerOrderMainDiv}`}>
                                            <Link className={`${styles.sellerReturnDBAnchor}`} to={`${userUrl}/product/${item.prod}/${item.id}`} target="_blank">
                                                <span className={`${styles.sellerReturnDBFont}`}>{item.name}</span>
                                                <div>
                                                    <img className={`${styles.sellerDBPRODIMG}`} id={index} src={`${S3_URL}/${item.photo1}`} alt={index}></img>
                                                </div>
                                                <div className={`${styles.sellerOrderAddressDiv}`}>
                                                    <span className={`${styles.sellerReturnDBFont}`}>Size: {item.size}</span>
                                                    <span className={`${styles.sellerReturnDBFont}`}>Name: {item.fname} {item.lname}</span>
                                                    <span className={`${styles.sellerReturnDBFont}`}>House no: {item.houseno}</span>
                                                    <span className={`${styles.sellerReturnDBFont}`}>Road: {item.roadName}</span>
                                                    <span className={`${styles.sellerReturnDBFont}`}>Area:{item.areaName}</span>
                                                    <span className={`${styles.sellerReturnDBFont}`}>City {item.city}</span>
                                                    <span className={`${styles.sellerReturnDBFont}`}>Pin: {item.pin}</span>
                                                    <span className={`${styles.sellerReturnDBFont}`}>Ph no. {item.phoneNo}</span>
                                                    <span className={`${styles.sellerReturnDBFont}`}>Alt. Ph. No.{item.altPhoneNo}</span>
                                                    <span className={`${styles.sellerReturnDBFont}`}>Price: {item.price}</span>
                                                </div>
                                            </Link>
                                            {!(role && role === 'designer') && (
                                                <button onClick={() => proceeded(item.purchaseId)} className={`${styles.sellerOrderBtn}`}>Accept order!</button>
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                            <div style={!(noOfObs > 10) ? { display: 'none' } : { display: 'block' }}>
                                <button onClick={(e) => { changePage(e, true); setPageno(pageno - 1) }} style={pageno < 2 ? { display: 'none' } : { display: 'block' }}>Prev</button>
                                <span>{pageno}</span>
                                <button onClick={(e) => { changePage(e, false); setPageno(pageno + 1) }} >Next</button>
                            </div>
                        </div>
                    </>)}

        </>
    )
}